export const QUALIFIED_BILLS_PART_TYPE = 0;
export const CERTIFIER_DATA_PART_TYPE = 1;
export const EXPORTER_DATA_PART_TYPE = 2;
export const PRODUCER_DATA_PART_TYPE = 3;
export const IMPORTER_DATA_PART_TYPE = 4;
